import React, { useMemo } from 'react'
import styled from 'styled-components'
import { IPalletDetails } from '../../../../modules/API/Pallets/models/palletDetails'
import { QuantityMap } from '../types/transferTeuda.types'
import ProductCard from './ProductCard'

type Props = {
  items: IPalletDetails[]
  quantities: QuantityMap
  searchQuery: string
  onQtyChange: (recID: number, qty: number) => void
}

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6em;
  overflow-y: auto;
  flex: 1;
  padding: 0 0.3em;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c8d4de;
    border-radius: 4px;
  }
`

const EmptyMessage = styled.p`
  text-align: center;
  color: #8a9ab0;
  font-size: 0.9rem;
  padding: 2em 0;
  direction: rtl;
`

const ProductCardList = ({ items, quantities, searchQuery, onQtyChange }: Props) => {
  const filteredItems = useMemo(() => {
    const query = searchQuery.trim().toLowerCase()
    if (!query) return items
    return items.filter((item) =>
      `${item.ProductDesc} ${item.VarietyDesc} ${item.Pack_Name}`
        .toLowerCase()
        .includes(query)
    )
  }, [items, searchQuery])

  if (filteredItems.length === 0) {
    return <EmptyMessage>לא נמצאו פריטים</EmptyMessage>
  }

  return (
    <ListWrapper>
      {filteredItems.map((item) => (
        <ProductCard
          key={item.RecID}
          item={item}
          quantity={quantities[item.RecID] ?? 0}
          onChange={onQtyChange}
        />
      ))}
    </ListWrapper>
  )
}

export default ProductCardList
